export const SortDescTableIcon = () => {
  return (
    <svg width="10" height="14" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333008 4L3.66634 0.5L6.99967 4H0.333008Z" fill="gray" />
      <path d="M3.66634 11.5L0.333008 8H6.99967L3.66634 11.5Z" fill="#2A295C" />
    </svg>
  )
}
